import React from "react";
import "./style.scss";
import { Navbar } from "@Components";
import { SignupForm } from "@Components/Signup";
import { Dialog, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";

const Header: React.FC<{
    showNav: boolean;
    showJoinButton: boolean;
}> = ({ showNav, showJoinButton }) => {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleCallback = (childData: boolean) => {
        if (childData) {
            handleClose();
        }
    };
    return (
        <>
            <header className="Header">
                <div className="Header-container">
                    <a href="/" className="logo">
                        <div
                            className="Header-logo"
                            style={{
                                backgroundImage: "url('/images/tb-logo.png')",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundSize: "contain",
                            }}
                        />
                    </a>
                    {showNav && <Navbar />}
                    {showJoinButton && (
                        <div className="Menu">
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <button
                                    onClick={handleOpen}
                                    style={{ minWidth: "50px", width: "auto" }}
                                    className="ButtonLogin ButtonLogin-gray"
                                >
                                    {t("signup.join_now")}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                <div>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogContent>
                            <SignupForm parentCallback={handleCallback} />
                        </DialogContent>
                    </Dialog>
                </div>
            </header>
        </>
    );
};

export { Header };
